(ns app.front.view.committees.core
  (:require [app.domain.committee.model :as committee-model]
            [app.domain.group.config.model :as config-model]
            [app.domain.party.model :as party-model]
            [app.domain.util :as du]
            [app.domain.workspace.model :as workspace-model]
            [app.front.entities :as entities]
            [app.front.entity-edit :as ee]
            [app.front.process :as process]
            [app.front.query.core :as query]
            [app.front.query.process :as process-query]
            [app.front.ui :as ui]
            [app.front.ui.action-bar :as ui-action-bar]
            [app.front.ui.add-widget :as ui-add]
            [app.front.ui.collapsible :as collapsible]
            [app.front.ui.dnd :as dnd]
            [app.front.ui.rich-text :as ui-rt]
            [app.front.ui.section :as section]
            [app.front.ui.select :as ui-select]
            [app.front.util :as futil :refer [for-frag]]
            [app.front.view.committees.common :as committee-common]
            [app.front.view.committees.subs :as committee-subs]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.href :as href]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]
            [schema.core :as s]))


(defn add-meeting [{:keys [committee-id]}]
  (r/with-let [committees (<sub [::committee-subs/committees])
               *params    (r/atom {:committee (p/find-first committees {:db/id committee-id})})
               set-val    (partial swap! *params assoc)]
    (let [tr                                      (<sub [:tr])
          lang                                    (<sub [:language])
          {:keys [:committee-meeting/date
                  :committee-meeting/description]
           :as   params}                          @*params
          disabled?                               (or (-> params :committee-meeting/date nil?)
                                                      (-> params :committee nil?))]
      [:div.mb-4
       [ui-add/add-widget
        {:icon    i/calendar
         :title   (tr [:committee/create-meeting])
         :buttons [{:text     (tr [:cancel])
                    :on-click #(>evt [::committee-subs/hide-add-meeting committee-id])}
                   {:disabled? disabled?
                    :on-click  #(>evt [::committee-subs/create-meeting
                                       (-> params
                                           (dissoc :committee)
                                           (assoc :committee-id
                                                  (-> params :committee :db/id)))])
                    :text      (tr [:create])}]}
        [:div.flex.flex-col.lg:flex-row
         [:div
          [ui-select/select {:id           "add-meeting-committee-id"
                             :class-name   "mb-4 full-width-select"
                             :label-text   (tr [:committee/meeting-type])
                             :hide-label   false
                             :required     true
                             :allow-empty? false
                             :value        (:committee params)
                             :values       committees
                             :val->str     #(committee-model/committee-name % lang)
                             :on-change    #(set-val :committee %)}]
          [ui/date-picker {:label-text (tr [:committee/meeting-date])
                           :required?  true?
                           :min-date   (date-util/today-start-of-day)
                           :callback   #(set-val :committee-meeting/date
                                                 (if (and date (some? %))
                                                   (date-util/set-hours-and-minutes % (.getHours date) (.getMinutes date))
                                                   %))
                           :value      date}]
          [ui/time-input {:label-text (tr [:committee/meeting-time])
                          :class      "mt-4"
                          :on-change  (fn [[hour minute]]
                                        (set-val
                                          :committee-meeting/date
                                          (date-util/set-hours-and-minutes
                                            (or (date-util/start-of-day date) (js/Date.))
                                            hour
                                            minute)))
                          :value      (if date
                                        [(.getHours date) (.getMinutes date)]
                                        [12 0])}]]

         [:div.flex-1.lg:ml-8
          [:label.bx--label (tr [:committee/meeting-description])]
          [ui-rt/editor-legacy {:initial-value description
                                :id            (str committee-id "new-meeting-description")
                                :on-change     #(set-val :committee-meeting/description %)}]]]]])))

(defn deficiency-row [{:keys [deficiency selected? on-toggle inactive?]}]
  (let [deficiency-id (:db/id deficiency)
        reference     (:inspection.deficiency/reference deficiency)
        description   (:inspection.deficiency/description deficiency)]
    [:div.deficiency-row
     {:class    (cond
                  inactive? "deficiency-row--inactive"
                  selected? "deficiency-row--selected")
      :on-click #(on-toggle deficiency-id)}
     [:div.deficiency-row__checkbox
      [cc/checkbox {:id         (str "deficiency-check-" deficiency-id)
                    :label-text ""
                    :hide-label true
                    :checked    selected?
                    :on-change  #(on-toggle deficiency-id)}]]
     [:div.deficiency-row__reference
      [ui-rt/editor-legacy {:initial-value reference}]]
     [:div.deficiency-row__description
      [ui-rt/editor-legacy {:initial-value description}]]]))

(defn deficiency-selection-list [{:keys [tr item-id selected-ids on-toggle existing-deficiencies]}]
  (let [active-deficiencies (<sub [::committee-subs/item-workspace-deficiencies item-id])
        active-id-set       (du/entity-id-set active-deficiencies)
        inactive-existing   (->> existing-deficiencies
                                 (remove #(contains? active-id-set (:db/id %))))
        all-deficiencies    (concat active-deficiencies inactive-existing)]
    (when (seq all-deficiencies)
      [:div.mt-6
       [:label.bx--label (tr [:committee/include-deficiencies-to-agenda])]
       [:div.deficiency-list.max-h-64.overflow-y-auto
        (for-frag [deficiency all-deficiencies]
          [deficiency-row {:deficiency deficiency
                           :selected?  (contains? selected-ids (:db/id deficiency))
                           :on-toggle  on-toggle
                           :inactive?  (not (contains? active-id-set (:db/id deficiency)))}])]])))

(defn agenda-item-edit-form [{:keys [item]}]
  (r/with-let [deficiencies    (:committee-item/deficiencies item)
               initial-def-ids (du/entity-id-set deficiencies)
               *selected-ids   (r/atom initial-def-ids)]
    (let [item-id                 (:db/id item)
          workspace               (:committee-item/item item)
          execution               (workspace-model/workspace-execution workspace)
          application             (workspace-model/workspace-application workspace)
          phase-entity            (or execution application)
          tr                      (-> (<sub [:tr])
                                      (workspace-model/workspace-tr-fn workspace))
          selected-deficiency-ids @*selected-ids
          has-changes?            (not= selected-deficiency-ids initial-def-ids)
          saving?                 (<sub [::process/signal-processing? :process.signal/edit-committee-meeting-item])]
      [:div.bg-ui-blue-10.border-2.border-solid.border-ui-blue-100.rounded-md.shadow-lg.mb-1.animation-appear-slide-down
       [:div.p-6
        [deficiency-selection-list {:tr                    tr
                                    :item-id               item-id
                                    :selected-ids          selected-deficiency-ids
                                    :on-toggle             (fn [def-id]
                                                             (swap! *selected-ids util/toggle-in-set def-id))
                                    :existing-deficiencies deficiencies}]
        [:div.flex.flex-row.justify-end.mt-4
         (cc/button {:on-click #(>evt [::committee-subs/clear-editing-item])
                     :kind     :tertiary}
                    (tr [:cancel]))
         (if saving?
           (cc/inline-loading {:description (tr [:saving])
                               :class-name  "ml-4"})
           (cc/button {:on-click   #(>evt [::process/signal
                                           (:db/id phase-entity)
                                           [:process.signal/edit-committee-meeting-item
                                            {:description        (or (:committee-item/description item) "")
                                             :meeting-item-id    item-id
                                             :committee-group-id (-> item committee-model/meeting-item-group :db/id)
                                             :deficiency-ids     (vec selected-deficiency-ids)}]
                                           {:on-done [::committee-subs/clear-editing-item]
                                            :notify  {:success :changes-saved}}])
                       :kind       :primary
                       :class-name "ml-2"
                       :disabled   (not has-changes?)}
                      (tr [:save-changes])))]]])))

(defn agenda-item-info [label value]
  [:div.bx--col-xs-12.bx--col-lg-6.bx--col-xl-4
   [:div.text-xs.text-gray-600.pb-2.pr-4 label]
   [:div.pb-6.pr-4
    (if (<sub [::query/fetching? :committee/meetings])
      (cc/skeleton-text)
      value)]])

(def left-bar
  :div.w-14.flex.items-center.justify-center)

(defn state-icon [{:keys [tr state]}]
  (when-let [icon (committee-common/item-status->icon state)]
    (cc/icon (util/mmap {:description (tr [state])
                         :fill        "currentcolor"}
                        icon))))

(defn state-classes [state]
  (case state
    :committee-item.state/done      "bg-ui-green text-white"
    :committee-item.state/postponed "bg-ui-gray text-gray-600"
    :committee-item.state/canceled  "bg-ui-gray text-gray-600"
    "bg-ui-night-sky text-white"))

(defn agenda-item [{:keys [item
                           editable?
                           on-toggle
                           checked
                           augment-draggable-props
                           augment-target-props
                           status-text]}]
  (let [item-id        (:db/id item)
        workspace      (:committee-item/item item)
        target         (workspace-model/workspace-target workspace)
        tr             (-> (<sub [:tr])
                           ;; use less efficient wrapper, because we can't use `::ws-subs/*` here
                           (workspace-model/workspace-tr-fn workspace))
        lang           (<sub [:language])
        applicant-name (->> (party-model/active-parties-for-the-role target :role/applicant)
                            (map #(party-model/corporation-and-full-name-or-full-name % lang))
                            sort
                            (str/join ", "))
        deficiencies   (:committee-item/deficiencies item)]
    [:div.bg-gray-200.mb-1.flex.flex-row (augment-target-props {} item)
     (if (and editable? on-toggle)
       [:label.w-16.flex.items-center.justify-center.flex-col.cursor-pointer
        {:class (futil/cs (if checked "bg-ui-violet-100 hover:bg-ui-violet-90" "bg-ui-violet-10 hover:bg-ui-violet-20"))}
        [:span
         (cc/checkbox {:id         (str "agenda-item-check-" item-id)
                       :label-text ""
                       :hide-label true
                       :checked    checked
                       :on-change  #(on-toggle item-id)})]]
       (let [state (:domain/state item)]
         (case state
           (:committee-item.state/postponed :committee-item.state/done :committee-item.state/canceled)
           [left-bar
            {:class (state-classes state)}
            [state-icon (util/mmap state tr)]]
           [left-bar
            (-> {:class (state-classes state)}
                (augment-draggable-props item))
            (cc/icon {:icon        i/draggable
                      :description (tr [:reorder])
                      :fill        "currentcolor"})])))
     [:div.flex-1
      [:div.pt-4.pb-0.px-6
       [:div.bx--row
        [agenda-item-info (tr [:workspace/address])
         (cc/link {:href (href/href :view/workspace {:workspace-id (:workspace/id workspace)})}
                  (:workspace/address workspace))]
        [agenda-item-info (tr [:property/id]) (-> workspace :workspace/primary-property :property/id)]
        [agenda-item-info (tr [:committee/status]) (tr [(:domain/state target)])]
        [agenda-item-info (tr [:committee/applicant]) applicant-name]
        [agenda-item-info (tr [:committee/category]) (config-model/category-name workspace lang)]
        (let [description (:committee-item/description item)]
          (when (not (ui-rt/empty-texts? description))
            [agenda-item-info (tr [:committee/agenda-item-description])
             [ui-rt/editor-legacy {:key           (str "agenda-item-description-" item-id)
                                   :initial-value description}]]))]
       (when (<sub [::ff/enabled? :feature-flag.id/domain-level-meetings])
         (let [available-deficiencies (<sub [::committee-subs/item-workspace-deficiencies item-id])]
           (cond
             (seq deficiencies)
             (r/with-let [*open? (r/atom false)]
               [:div.mt-2.pb-4
                [collapsible/collapsible
                 {:open?     @*open?
                  :on-toggle #(swap! *open? not)
                  :variant   :border
                  :header    [:div.flex-1.py-3.px-4.pr-8.font-semibold
                              (tr [:committee/associated-deficiencies])
                              " (" (count deficiencies) ")"]}
                 [:div.deficiency-list.px-4.py-2
                  (for-frag [deficiency deficiencies]
                    [:div.deficiency-display
                     [:div.deficiency-row__reference
                      [ui-rt/editor-legacy {:initial-value (:inspection.deficiency/reference deficiency)}]]
                     [:div.deficiency-row__description
                      [ui-rt/editor-legacy {:initial-value (:inspection.deficiency/description deficiency)}]]])
                  (when editable?
                    [:div.flex.justify-end.pt-2
                     (cc/button {:icon     i/pen
                                 :kind     :ghost
                                 :size     :small
                                 :on-click #(>evt [::committee-subs/set-editing-item item-id])}
                                (tr [:edit]))])]]])

             (and editable? (seq available-deficiencies))
             [:div.mt-2.pb-4
              (cc/button {:kind       :ghost
                          :size       :small
                          :class-name "whitespace-nowrap"
                          :on-click   #(>evt [::committee-subs/set-editing-item item-id])}
                         (tr [:committee/include-deficiencies-to-agenda]))]

             :else nil)))]
      (when status-text
        [:div.border-solid.border-t.border-ui-dark-gray.p-6.uppercase.font-bold.text-ui-night-sky
         status-text])]]))


(defn spinner-button [{:keys [on-click loading? kind tr confirm]} content]
  (if loading?
    (cc/loading-spinner {:small true :with-overlay false})
    (if (not-empty confirm)
      [ui/modal-confirmation-button
       {:tr                  tr
        :modal-title         content
        :trigger-button-opts (merge {:class-name "ml-2"}
                                    (when-not (nil? kind) {:kind kind}))
        :trigger-button-text content
        :no-button-text      (tr [:no])
        :yes-button-text     (tr [:yes])
        :on-yes-click        on-click}
       [:div confirm]]
      (cc/button (merge {:on-click   on-click
                         :class-name "ml-2"}
                        (when-not (nil? kind) {:kind kind}))
                 content))))


(defn change-meeting-button [{:keys [event command meeting-id additional-data kind tr-key confirm]}]
  (let [tr (<sub [:tr])]
    [spinner-button
     {:on-click #(>evt [event meeting-id additional-data])
      :kind     kind
      :loading? (<sub [::committee-subs/meeting-change-loading? command meeting-id])
      :tr       tr
      :confirm  confirm}
     (tr [(or tr-key command)])]))


(defn meeting-item-time-inputs [tr meeting]
  (let [meeting-id (:db/id meeting)
        date       (<sub [::ee/attr-value meeting-id :committee-meeting/date])]
    [:div.flex.flex-col.md:flex-row.items-center.pb-8
     [ui/date-picker {:label-text (tr [:committee/meeting-date])
                      :required?  true?
                      :min-date   (date-util/today-start-of-day)
                      :callback   #(>evt [::ee/set-value
                                          meeting-id
                                          :committee-meeting/date
                                          (if (and date (some? %))
                                            (date-util/set-hours-and-minutes % (.getHours date) (.getMinutes date))
                                            %)])
                      :value      date}]
     [ui/time-input {:label-text (tr [:committee/meeting-time])
                     :class      "ml-2"
                     :on-change  (fn [[hour minute]]
                                   (rf/dispatch-sync [::ee/set-value
                                                      meeting-id
                                                      :committee-meeting/date
                                                      (date-util/set-hours-and-minutes
                                                        (or (date-util/start-of-day date) (js/Date.))
                                                        hour
                                                        minute)]))
                     :value      (if date
                                   [(.getHours date) (.getMinutes date)]
                                   [12 0])}]]))


(defn meeting-item-header [tr meeting]
  (let [agenda-items (<sub [::committee-subs/agenda-items (:db/id meeting)])
        state        (:domain/state meeting)]
    [:div.flex.flex-row.items-center
     [ui/pill {:color (case state
                        :committee-meeting.state/passed :green
                        :committee-meeting.state/cancelled :gray
                        :dark-blue)
               :text  (count agenda-items)}]
     [:div.text-xl ((<sub [::date-util/date-time-fn]) (:committee-meeting/date meeting))]
     (case state
       :committee-meeting.state/passed
       [:div.text-ui-green.ml-4.flex.flex-row.justify-end.items-center.font-normal
        (cc/icon {:icon        i/check
                  :description ""
                  :aria-hidden true
                  :fill        "currentcolor"})
        [:span.text-xl.uppercase.ml-2.text-ui-night-sky (tr [state])]]
       :committee-meeting.state/cancelled
       [:div.text-gray-500.ml-4.flex.flex-row.justify-end.items-center.font-normal
        (cc/icon {:icon        i/remove
                  :description ""
                  :aria-hidden true
                  :fill        "currentcolor"})
        [:span.text-xl.uppercase.ml-2.text-ui-night-sky (tr [state])]]
       nil)]))

(defn download-button [{:keys [tr url text]}]
  (r/with-let [*clicked (r/atom false)]
    (if @*clicked
      [:div.ml-4.flex
       (cc/inline-loading {:description   (tr [:committee/download-in-progress])
                           :success       true
                           :success-delay 5000
                           :on-success    #(reset! *clicked false)})]
      (cc/button {:href       url
                  :kind       :tertiary
                  :on-click   #(reset! *clicked true)
                  :disabled   @*clicked
                  :icon       i/download
                  :class-name "ml-4"
                  :download   ""}
                 text))))

(defn download-buttons [{:keys [tr meeting-id]}]
  [:<>
   [download-button (util/mmap {:url  (str "/api/command/committee/download-agenda?meeting-id=" meeting-id)
                                :text (tr [:committee/download-agenda])}
                               tr)]
   [download-button (util/mmap {:url  (str "/api/command/committee/download-meeting-pkg?meeting-id=" meeting-id)
                                :text (tr [:committee/download-meeting-pkg])}
                               tr)]])

(defn meeting-item [meeting]
  (let [meeting-id        (:db/id meeting)
        mode              (<sub [::committee-subs/mode meeting-id])
        tr                (<sub [:tr])
        editable?         (du/in-state? :committee-meeting.state/active meeting)
        agenda-items      (<sub [::committee-subs/agenda-items meeting-id])
        item-ids          (du/entity-id-set agenda-items)
        editing?          (<sub [::ee/has-changes? meeting-id])
        selected-item-ids (<sub [::committee-subs/selected-items])
        editing-item-id   (<sub [::committee-subs/editing-item-id])]
    [section/section
     (str "meeting-" meeting-id)
     {:tr    tr
      :class (when editing? "bg-ui-violet-10 shadow-lg")}
     (meeting-item-header tr meeting)
     [:div
      [:div.md:pl-20.mb-6
       (when editing?
         [:<>
          [meeting-item-time-inputs tr meeting]
          [:div.bx--label (tr [:committee/meeting-description])]])
       (when (or editing? (-> meeting :committee-meeting/description ui-rt/empty-texts? not))
         [ui-rt/editor-legacy (merge
                                {:id            (str "meeting-description-" meeting-id)
                                 :key           (str "meeting-description-" meeting-id)
                                 :initial-value (:committee-meeting/description meeting)}
                                (when editing?
                                  {:on-change #(>evt [::ee/set-value meeting-id :committee-meeting/description %])}))])]
      (when (= mode :close)
        [:div.mb-6.sticky.top-15.bg-ui-white.z-10
         ;; .top-15 matches with the committees page sticky breadcrumb header - if that ever changes,
         ;; this will start looking funny, but hopefully remains usable.
         [ui-action-bar/action-bar
          {:actions [{:description (tr [:multi-select/select-all])
                      :disabled    (<sub [::committee-subs/all-selected? meeting-id])
                      :on-click    #(>evt [::committee-subs/set-selection item-ids])}
                     {:description (tr [:multi-select/select-none])
                      :disabled    (<sub [::committee-subs/none-selected?])
                      :on-click    #(>evt [::committee-subs/set-selection #{}])}]}
          (if (<sub [::process-query/loading?])
            (cc/loading-spinner {:small true :with-overlay false})
            [ui-select/select {:id              "meeting-end-action-select"
                               :values          (<sub [::committee-subs/possible-actions-for-selected])
                               :disabled-values (<sub [::committee-subs/disabled-actions-for-selected])
                               :val->str        (comp tr vector)
                               :value           (<sub [::committee-subs/selected-action-for-selection])
                               :inline-label?   true
                               :label-text      (tr [:committee-meeting/set-workspace-as])
                               :allow-empty?    false
                               :on-change       (fn [action-def]
                                                  (>evt [::committee-subs/select-action selected-item-ids action-def]))}])]])
      (when-not editing?
        (if (seq agenda-items)
          [:div.mb-8
           [dnd/wrap-dnd
            {:id               (str "meeting-agenda-dnd-" meeting-id)
             :items            agenda-items
             :props-for-source {:class "bg-gray-300"}
             :on-reorder       #(>evt [::committee-subs/reorder-agenda %1 %2])}
            (fn [{:keys [sorted]
                  :as   drag-props}]
              [:div
               (for-frag [item sorted]
                 (if (= editing-item-id (:db/id item))
                   [agenda-item-edit-form {:item item}]
                   [agenda-item (merge drag-props
                                       (if (= mode :close)
                                         {:checked     (<sub [::committee-subs/item-selected? (:db/id item)])
                                          :status-text (<sub [::committee-subs/selected-action-text (:db/id item)])
                                          :on-toggle   (fn [item-id]
                                                         (>evt [::committee-subs/toggle-item-selected item-id]))}
                                         {:checked     false
                                          :status-text (when-let [action (:committee-item/selected-action item)]
                                                         (tr [action]))})
                                       (util/mmap item editable?))]))])]]
          [:div.md:pl-20.text-gray-500 (tr [:committee/no-meeting-agenda-items])]))]
     (if editing?
       [:div.mt-4.flex.flex-row.justify-end
        (cc/button {:on-click #(>evt [::ee/cancel-changes meeting-id])
                    :kind     :tertiary}
                   (tr [:cancel]))
        (cc/button {:on-click   #(>evt [::ee/save-changes nil :committee/edit-meeting meeting-id])
                    :class-name "ml-2"}
                   (tr [:save]))]
       (when (= (:domain/state meeting) :committee-meeting.state/active)
         [:div
          [:div.mt-4.flex.flex-row.flex-wrap.justify-end
           (when (seq agenda-items)
             [download-buttons (util/mmap tr meeting-id)])
           [:div.flex-1]
           (when-not (= mode :close)
             [:<>
              (cc/button {:kind     :tertiary
                          :on-click #(>evt [::ee/set-values
                                            meeting-id
                                            (select-keys meeting [:committee-meeting/date
                                                                  :committee-meeting/description])])}
                         (tr [:edit]))
              [change-meeting-button (util/mmap {:command :committee/cancel-meeting
                                                 :event   ::committee-subs/cancel-meeting
                                                 :kind    :tertiary
                                                 :confirm (tr [:committee-meeting/cancel-confirm])}
                                                meeting-id)]])
           (if (= mode :close)
             [:div
              (cc/button {:on-click #(>evt [::committee-subs/set-mode meeting-id :default])
                          :kind     :tertiary}
                         (tr [:cancel]))
              [change-meeting-button
               (util/mmap {:command         :committee/complete-meeting
                           :tr-key          :committee/ok
                           :event           ::committee-subs/complete-meeting
                           :additional-data (<sub [::committee-subs/additional-complete-meeting-data meeting-id])}
                          meeting-id)]]
             (cc/button {:on-click   (fn [_]
                                       (>evt [::committee-subs/set-mode meeting-id :close])
                                       (>evt [::process-query/check-signals-permitted
                                              (->> agenda-items
                                                   (map :committee-item/item)
                                                   (reduce (fn [acc workspace]
                                                             (assoc-in acc
                                                                       [(:workspace/id workspace)
                                                                        :entity.type/application]
                                                                       committee-subs/meeting-close-signals))
                                                           {}))]))
                         :class-name "ml-2"}
                        (tr [:committee/complete-meeting])))]]))]))


(defn committee-section []
  (let [tr           (<sub [:tr])
        lang         (<sub [:language])
        committee    (<sub [::committee-subs/selected-committee])
        description  (committee-model/committee-description committee lang)
        committee-id (:db/id committee)
        meetings     (<sub [::committee-subs/meetings committee-id])]
    [:<>
     (when-not (empty? description)
       [:div.py-4.px-8.leading-normal.whitespace-pre-wrap
        description])
     (if (seq meetings)
       [:div
        (for-frag [[_ meeting] (->> meetings
                                    (map-indexed vector))]
          [meeting-item meeting])]
       [:div.flex.flex-col.items-center.justify-center.text-xl.text-gray-400.mt-4.py-16.xl:py-32.px-8.text-center.bg-white
        (tr [:committee/no-meetings-selected-time] [(committee-model/committee-name committee lang)])])]))


(defn committee-selector []
  (let [selected-committee-id (<sub [::committee-subs/selected-committee-id])
        group-id              (<sub [::committee-subs/pre-selected-group-id])
        lang                  (<sub [:language])]
    [:div.flex.flex-row.flex-wrap
     (for-frag [{committee-id :db/id :as committee} (<sub [::committee-subs/committees])]
       [:div.flex.w-min
        [:a.block.p-4.border-b-2.border-solid.border-gray-400.no-underline.text-black.hover:border-ui-blue-100
         {:href (href/href :view/committee
                           (util/mmap committee-id)
                           (when group-id
                             {:group-id group-id}))

          :class (when (= committee-id selected-committee-id) "border-ui-blue-100 font-bold")}
         (committee-model/committee-name committee lang)]])]))



(defn date-range-selector []
  (let [tr (<sub [:tr])]
    [:div.flex.flex-col.md:flex-row
     [ui/date-picker {:callback  #(>evt [::committee-subs/select-date-range-start (date-util/start-of-day %)])
                      :value     (<sub [::committee-subs/date-range-start])
                      :disabled? false
                      :tr        tr}]
     [:div.md:p-4 " - "]
     [ui/date-picker {:callback  #(>evt [::committee-subs/select-date-range-end (date-util/end-of-day %)])
                      :value     (<sub [::committee-subs/date-range-end])
                      :disabled? false
                      :tr        tr}]]))


(defn view [_]
  (let [committee-id (<sub [::committee-subs/selected-committee-id])
        tr           (<sub [:tr])]
    [:div.cloudpermit-page
     [:div.bx--row.page-heading
      [:div.bx--col-xs-12.bx--col-sm-6>h1 (tr [:committee/meetings])]
      (when (<sub [::committee-subs/can-add-meeting?])
        [:div.bx--col-xs-12.bx--col-sm-6.flex
         (cc/button {:kind             :primary
                     :on-click         #(>evt [::committee-subs/show-add-meeting committee-id])
                     :class-name       "ml-auto"
                     :icon             i/calendar
                     :icon-description ""}
                    (tr [:committee/create-meeting]))])]
     [:div.bx-row
      [:div.bx--col-xs-12
       [committee-common/add-widget
        {:state (<sub [::committee-subs/add-meeting-status committee-id])}
        [add-meeting {:committee-id committee-id}]]]]
     [:div.bx--row
      [:div.bx--col-xs-12.bx--col-xl-6.pb-4 [committee-selector]]
      [:div.bx--col-xs-12.bx--col-xl-6.flex.flex-row.md:justify-end.pb-4 [date-range-selector]]]
     [committee-section]]))


(defn single-committee-breadcrumb [{:keys [tr match]}]
  (let [lang                  (<sub [:language])
        {:keys [committee-id]
         :as   params}        (-> match :parameters :path)]
    [:view/committee params (tr [:committee/committee-name-meetings]
                                [(-> (<sub [::entities/entity committee-id])
                                     (committee-model/committee-name lang))])]))

(defn committees-breadcrumb [{:keys [tr match]}]
  (let [params (-> match :parameters :path)]
    [:view/committees params (tr [:view/committees])]))

(def route-all
  {:name :view/committees
   :view view})


(def route-one
  {:name        :view/committee
   :breadcrumb  {:items [single-committee-breadcrumb]}
   :view        view
   :parameters  {:path {:committee-id s/Int}}
   :controllers [{:parameters {:path [:committee-id]}
                  :start      (fn [{{:keys [committee-id]} :path}]
                                (>evt [::query/fetch
                                       :committee/meetings
                                       (merge {:committee-id committee-id}
                                              (committee-subs/get-default-date-range))])
                                (>evt [::committee-subs/set-committee-id committee-id]))}]})
